import FormSubmit from 'containers/form-submit/formSubmit';

export default FormSubmit;
